import useGetMockups from './useGetMockups'

export default useGetMockups
